import { render, staticRenderFns } from "./Multicolumn.vue?vue&type=template&id=28fa9944&"
import script from "./Multicolumn.vue?vue&type=script&lang=js&"
export * from "./Multicolumn.vue?vue&type=script&lang=js&"
import style0 from "./Multicolumn.vue?vue&type=style&index=0&id=28fa9944&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports